import { render, staticRenderFns } from "./BigGoal.vue?vue&type=template&id=f380828a&scoped=true"
import script from "./BigGoal.vue?vue&type=script&lang=js"
export * from "./BigGoal.vue?vue&type=script&lang=js"
import style0 from "./BigGoal.vue?vue&type=style&index=0&id=f380828a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f380828a",
  null
  
)

export default component.exports